/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:13:15
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/indexAnchor.js
 */
export default {
    // indexAnchor 组件
    indexAnchor: {
        text: '',
        color: '#606266',
        size: 14,
        bgColor: '#dedede',
        height: 32
    }
}
